<div>
    <h3>{{ 'PAGE.BLOG.LATEST_ARTICLES' | translate }}</h3>
    <br />
    <ul class="list-unstyled">
        <li *ngFor="let preview of blogPostPreviews">
            <a [href]="getUrl(preview.url)">{{ preview.name }}</a>
        </li>
    </ul>
</div>
